module.exports = __webpack_public_path__ + "static/img/1.b054181.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/1.png
// module id = Ld51
// module chunks = 0